export const exportReportOptions = {
  woundEvaluations: "woundEvaluations"
  // Possible Future Options:
  // surveillance: "Surveillance",
  // patientList: "Patient List",
  // patientHistory: "Patient History"
};
